"use client";
import { useState } from "react";
import Modal from "../ui/Modal";

const Footer = () => {
  const [openModal, setOpenModal] = useState<null | "help" | "faq" | "privacy">(
    null
  );
  const close = () => setOpenModal(null);
  return (
    <>
      <footer className="footer ">
        <section className="py-12 bg-white">
          <div className="container mx-auto">
            <div className="grid grid-cols-12 lg:gap-10">
              <div className="col-span-12 xl:col-span-4">
                <div className="mr-12">
                  <h4 className="text-gray-800 mb-6 text-[23px]">Staffing Solutions</h4>
                  <p className="text-gray-600">
                    It is a long established fact that a reader will be of a
                    page reader will be of at its layout.
                  </p>
                </div>
              </div>
              <div className="col-span-12 mt-8 md:col-span-6 xl:col-span-2 md:mt-0">
                {/* Company column removida conforme requisito */}
                {false && (
                  <div className="col-span-12 mt-8 md:col-span-6 xl:col-span-2 md:mt-0">
                    REMOVED
                  </div>
                )}
              </div>
              {/* Blocos 'For Jobs' e 'For Candidates' comentados a pedido do usuário. 
                            Para reativar basta trocar 'false' por 'true' ou remover o wrapper. */}
              {false && (
                <>
                  {/* For Jobs */}
                  <div className="col-span-12 mt-8 md:col-span-6 xl:col-span-2 md:mt-0">
                    <p className="mb-6 text-white text-16">For Jobs</p>
                    <ul className="space-y-4">
                      <li className="text-sm transition-all duration-500 ease-in-out text-white/50 hover:text-gray-50 hover:text-base dark:text-gray-300 dark:hover:text-gray-50">
                        <a href="job-categories.html">
                          <i className="mdi mdi-chevron-right"></i> Browser
                          Categories
                        </a>
                      </li>
                      <li className="text-sm transition-all duration-500 ease-in-out text-white/50 hover:text-gray-50 hover:text-base dark:text-gray-300 dark:hover:text-gray-50">
                        <a href="job-list.html">
                          <i className="mdi mdi-chevron-right"></i> Browser Jobs
                        </a>
                      </li>
                      <li className="text-sm transition-all duration-500 ease-in-out text-white/50 hover:text-gray-50 hover:text-base dark:text-gray-300 dark:hover:text-gray-50">
                        <a href="job-details.html">
                          <i className="mdi mdi-chevron-right"></i> Job Details
                        </a>
                      </li>
                      <li className="text-sm transition-all duration-500 ease-in-out text-white/50 hover:text-gray-50 hover:text-base dark:text-gray-300 dark:hover:text-gray-50">
                        <a href="bookmark-jobs.html">
                          <i className="mdi mdi-chevron-right"></i> Bookmark
                          Jobs
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* For Candidates */}
                  <div className="col-span-12 mt-8 md:col-span-6 xl:col-span-2 md:mt-0">
                    <p className="mb-6 text-white text-16">For Candidates</p>
                    <ul className="space-y-4">
                      <li className="text-sm transition-all duration-500 ease-in-out text-white/50 hover:text-gray-50 hover:text-base dark:text-gray-300 dark:hover:text-gray-50">
                        <a href="candidate-list.html">
                          <i className="mdi mdi-chevron-right"></i> Candidate
                          List
                        </a>
                      </li>
                      <li className="text-sm transition-all duration-500 ease-in-out text-white/50 hover:text-gray-50 hover:text-base dark:text-gray-300 dark:hover:text-gray-50">
                        <a href="candidate-grid.html">
                          <i className="mdi mdi-chevron-right"></i> Candidate
                          Grid
                        </a>
                      </li>
                      <li className="text-sm transition-all duration-500 ease-in-out text-white/50 hover:text-gray-50 hover:text-base dark:text-gray-300 dark:hover:text-gray-50">
                        <a href="candidate-details.html">
                          <i className="mdi mdi-chevron-right"></i> Candidate
                          Details
                        </a>
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <div className="col-span-12 mt-8 md:col-span-6 xl:col-span-2 md:mt-0">
                <p className="mb-6 text-gray-800 text-16">Support</p>
                <ul className="space-y-4">
                  <li
                    className="text-sm transition-all duration-500 ease-in-out text-gray-600 hover:text-gray-800 cursor-pointer"
                    onClick={() => setOpenModal("help")}
                  >
                    <i className="mdi mdi-chevron-right"></i> Help Center
                  </li>
                  <li
                    className="text-sm transition-all duration-500 ease-in-out text-gray-600 hover:text-gray-800 cursor-pointer"
                    onClick={() => setOpenModal("faq")}
                  >
                    <i className="mdi mdi-chevron-right"></i> FAQ&apos;S
                  </li>
                  <li
                    className="text-sm transition-all duration-500 ease-in-out text-gray-600 hover:text-gray-800 cursor-pointer"
                    onClick={() => setOpenModal("privacy")}
                  >
                    <i className="mdi mdi-chevron-right"></i> Privacy Policy
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="py-6 border-t bg-white border-gray-200">
          <div className="container mx-auto">
            <div className="text-center">
              <p className="mb-0 text-center text-gray-600">
                {`${new Date().getFullYear()} © Staffing Solutions LLC`}
              </p>
            </div>
          </div>
        </section>
      </footer>
      {/* Modals */}
      <Modal
        open={openModal === "help"}
        title="Help Center"
        onClose={close}
        size="md"
      >
        <h3 className="font-semibold mb-3 text-gray-800 dark:text-gray-200">
          How can we help?
        </h3>
        <p className="mb-4">
          Welcome to the Help Center. Here you can find guidance about using our
          platform effectively, from creating an account to managing job
          postings and tracking candidate engagement.
        </p>
        <ul className="list-disc pl-5 space-y-2 mb-4">
          <li>
            <strong>Account Access:</strong> Ensure your email is verified. If
            locked out, use the password recovery flow.
          </li>
          <li>
            <strong>Posting Opportunities:</strong> Provide clear titles,
            concise role summaries, and required certifications.
          </li>
          <li>
            <strong>Notifications:</strong> Adjust your alert preferences in
            Settings &gt; Preferences.
          </li>
        </ul>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Still need support? Reach out to our team and we will respond within 1
          business day.
        </p>
      </Modal>
      <Modal
        open={openModal === "faq"}
        title="Frequently Asked Questions"
        onClose={close}
        size="md"
      >
        <h3 className="font-semibold mb-3">Top Questions</h3>
        <div className="space-y-4 text-sm">
          <div>
            <p className="font-medium">How do I update my profile?</p>
            <p>
              Edit your profile details from the dashboard under{" "}
              <em>Profile Settings</em>. Changes save automatically.
            </p>
          </div>
          <div>
            <p className="font-medium">Can I save listings to review later?</p>
            <p>
              Yes. Use the bookmark icon on any job card. Access saved items
              from the Bookmarks panel.
            </p>
          </div>
          <div>
            <p className="font-medium">How frequently is data refreshed?</p>
            <p>
              Metrics and statuses refresh in near real time; manual refresh is
              rarely needed.
            </p>
          </div>
        </div>
        <p className="mt-5 text-xs text-gray-500 dark:text-gray-400">
          Didn’t find what you need? Contact support for a tailored answer.
        </p>
      </Modal>
      <Modal
        open={openModal === "privacy"}
        title="Privacy Policy"
        onClose={close}
        size="lg"
      >
        <p className="mb-4">
          We respect your privacy and are committed to protecting personal data.
          This summary explains what we collect, why, and your rights.
        </p>
        <h4 className="font-semibold mt-4 mb-2">1. Data We Collect</h4>
        <p className="mb-2">
          Identification data (name, email), usage analytics, session logs, and
          optional professional profile information you provide.
        </p>
        <h4 className="font-semibold mt-4 mb-2">2. How We Use It</h4>
        <ul className="list-disc pl-5 space-y-1 mb-3">
          <li>To operate and secure the platform</li>
          <li>To improve feature relevance and performance</li>
          <li>To communicate essential service updates</li>
        </ul>
        <h4 className="font-semibold mt-4 mb-2">3. Your Rights</h4>
        <p className="mb-2">
          You may request access, correction, export, or deletion of your
          personal data subject to legal retention duties.
        </p>
        <h4 className="font-semibold mt-4 mb-2">4. Data Retention</h4>
        <p className="mb-2">
          We retain data only as long as required for the purpose collected or
          compliance obligations.
        </p>
        <h4 className="font-semibold mt-4 mb-2">5. Contact</h4>
        <p>
          If you have a privacy request, please reach out to our compliance
          team. We respond within applicable regulatory timeframes.
        </p>
        <p className="mt-5 text-xs text-gray-500 dark:text-gray-400">
          This is a simplified overview. A full version can be provided upon
          request.
        </p>
      </Modal>
    </>
  );
};

export default Footer;
